@if (visualization === 'percentage_ring') {
  <div
    class="percentage-ring"
    role="img"
    [attr.aria-label]="formattedValue"
    [style.--percentage]="boundedPercentage"
  >
    <span>{{ formattedValue }}</span>
  </div>
} @else {
  <div class="report-number">{{ formattedValue }}</div>
  @if (visualization === 'percentage_bar') {
    <div
      class="percentage-track"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="boundedPercentage"
    >
      <span [style.width.%]="boundedPercentage"></span>
    </div>
  }
}
